/** zoom-lock.js: publishes --zoom-lock (= 1 / browser zoom) so the sticky chrome can hold the physical size it has at 100% instead of eating a growing share of a zoomed viewport; a zoom level it cannot read leaves the value at 1, i.e. today's behaviour untouched. */
(function () {
  var root = document.documentElement;

  // Zoom steps offered by Chrome, Firefox and Safari: a reading matching none of them is not a zoom level.
  var STEPS = [1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4, 5];
  var TOLERANCE = 0.06;

  // Under this the header is barely worth shrinking, and staying out keeps the common case strictly identical.
  var FLOOR = 1.25;

  // Desktop only: on a touch browser `outerWidth` answers for the visual viewport and pinch zoom, which this must not react to.
  var desktop = window.matchMedia("(hover: hover) and (pointer: fine)");

  /** `outerWidth` is in screen pixels, which page zoom leaves alone, while `innerWidth` is in page pixels, which it scales: their ratio is the zoom level, with no baseline to capture — so a page reloaded at a zoom the browser remembered reads as well as a live change, unlike devicePixelRatio. */
  function detectZoom() {
    // In an iframe (theme editor preview) `outerWidth` is the top window's, so the ratio measures the frame, not the zoom.
    if (window.self !== window.top) return 1;
    if (!window.outerWidth || !window.innerWidth) return 1;
    var raw = window.outerWidth / window.innerWidth;

    var closest = STEPS[0];
    for (var i = 0; i < STEPS.length; i++) {
      if (Math.abs(raw - STEPS[i]) < Math.abs(raw - closest)) closest = STEPS[i];
    }

    // Window frame, embedded context, browser we did not anticipate: scaling by a wrong factor would be worse than doing nothing.
    return Math.abs(raw - closest) / closest > TOLERANCE ? 1 : closest;
  }

  var current = null;

  function apply() {
    var zoom = desktop.matches ? detectZoom() : 1;
    var value = zoom >= FLOOR ? String(1 / zoom) : "1";
    if (value === current) return;

    current = value;
    root.style.setProperty("--zoom-lock", value);
    // The scale changes the painted height of everything it applies to, and whoever measures that height has to do it again. An explicit event rather than relying on the order two `resize` listeners happen to fire in.
    window.dispatchEvent(new CustomEvent("zoom-lock:change", { detail: { lock: parseFloat(value) } }));
  }

  apply();

  // Zooming has no event of its own; it resizes the viewport.
  window.addEventListener("resize", apply);
  if (desktop.addEventListener) desktop.addEventListener("change", apply);
  else desktop.addListener(apply);
})();
